// SEARCH

jQuery(document).ready(function($){

  $('.c-share').click(function() {
    $(this).children('ul').toggleClass('active');
  });

});
